import { useMutation } from 'react-query';
import axios from 'axios';
import { baseurl } from '../constant';
import { useAuth } from '../../../scripts/fb';
import { setLocalStorage } from '../utils';

export function useCollectionMutations() {
  const auth = useAuth();

  const geAllCollections = async () => {
    try {
      const token = await auth.user?.getIdToken();
      if (!token) return;
      const route = `${baseurl}/collections`;
      const response = await axios.get(route, {
        headers: {
          Authorization: token,
          'Cache-Control': 'no-store'
        }
      });
      if (response && response.status === 200) {
        const collections = response?.data?.result ?? [];
        return collections;
      }
    } catch (error: any) {
      if (
        error?.response?.status == 403 ||
        error?.message === 'auth.user?.getIdToken is not a function' ||
        error?.response?.status == 401
      ) {
        setLocalStorage('token', null);
        setLocalStorage('userData', null);
        window.open('/', '_self');
      }
    }
  };

  const geCollection = async (collection: string) => {
    try {
      const token = await auth.user?.getIdToken();
      if (!token) return;
      const route = `${baseurl}/collection/${collection}`;
      const response = await axios.get(route, {
        headers: {
          Authorization: token,
          'Cache-Control': 'no-store'
        }
      });
      if (response && response.status === 200) {
        const collection = response?.data?.result;
        return collection;
      }
    } catch (error: any) {
      if (
        error?.response?.status == 403 ||
        error?.message === 'auth.user?.getIdToken is not a function' ||
        error?.response?.status == 401
      ) {
        setLocalStorage('token', null);
        setLocalStorage('userData', null);
        window.open('/', '_self');
      }
      throw error;
    }
  };

  const geCollectionItems = async (collection: string) => {
    try {
      const token = await auth.user?.getIdToken();
      if (!token) return;
      const route = `${baseurl}/collection/${collection}/items`;
      const response = await axios.get(route, {
        headers: {
          Authorization: token,
          'Cache-Control': 'no-store'
        }
      });
      if (response && response.status === 200) {
        const collection = response?.data?.result;
        return collection;
      }
    } catch (error: any) {
      if (
        error?.response?.status == 403 ||
        error?.message === 'auth.user?.getIdToken is not a function' ||
        error?.response?.status == 401
      ) {
        setLocalStorage('token', null);
        setLocalStorage('userData', null);
        window.open('/', '_self');
      }
      throw error;
    }
  };

  const createCollection = useMutation(async (payload: any) => {
    const token = await auth.user?.getIdToken();
    if (!token) return;
    const route = `${baseurl}/collection/${payload.collection}`;
    try {
      const response = await axios.post(route, payload.body, {
        headers: { Authorization: token }
      });
      if (response && response.status === 200) {
        return response.data ?? 'ok';
      }
    } catch (error: any) {
      if (error?.response?.status === 403 || error?.response?.status === 401) {
        setLocalStorage('token', null);
        setLocalStorage('userData', null);
        window.open('/', '_self');
      }
      throw error;
    }
  });

  const createCollectionItem = useMutation(async (payload: any) => {
    const token = await auth.user?.getIdToken();
    if (!token) return;
    const route = `${baseurl}/collection/${payload.collection}/items`;
    try {
      const response = await axios.post(route, payload.body, {
        headers: { Authorization: token }
      });
      if (response && response.status === 200) {
        return response.data ?? 'ok';
      }
    } catch (error: any) {
      if (error?.response?.status === 403 || error?.response?.status === 401) {
        setLocalStorage('token', null);
        setLocalStorage('userData', null);
        window.open('/', '_self');
      }
      throw error;
    }
  });

  const updateCollectionItem = useMutation(async (payload: any) => {
    const token = await auth.user?.getIdToken();
    if (!token) return;
    const route = `${baseurl}/collection/${payload.collection}/item/${payload.id}`;
    console.log('data to update', payload.body);
    try {
      const response = await axios.put(route, payload.body, {
        headers: { Authorization: token }
      });
      if (response && response.status === 200) {
        return response.data ?? 'ok';
      }
    } catch (error: any) {
      if (error?.response?.status === 403 || error?.response?.status === 401) {
        setLocalStorage('token', null);
        setLocalStorage('userData', null);
        window.open('/', '_self');
      }
      throw error;
    }
  });

  const deleteCollectionItem = useMutation(async (payload: any) => {
    const token = await auth.user?.getIdToken();
    if (!token) return;
    const route = `${baseurl}/collection/${payload.collection}/item/${payload.id}`;
    try {
      const response = await axios.delete(route, {
        headers: { Authorization: token }
      });
      if (response && response.status === 200) {
        return response.data ?? 'ok';
      }
    } catch (error: any) {
      if (error?.response?.status === 403 || error?.response?.status === 401) {
        setLocalStorage('token', null);
        setLocalStorage('userData', null);
        window.open('/', '_self');
      }
      throw error;
    }
  });

  const updateCollection = useMutation(async (payload: any) => {
    const token = await auth.user?.getIdToken();
    if (!token) return;
    const route = `${baseurl}/collection/${payload.collection}`;
    try {
      const response = await axios.put(route, payload.body, {
        headers: { Authorization: token }
      });
      if (response && response.status === 200) {
        return response.data ?? 'ok';
      }
    } catch (error: any) {
      if (error?.response?.status === 403 || error?.response?.status === 401) {
        setLocalStorage('token', null);
        setLocalStorage('userData', null);
        window.open('/', '_self');
      }
      throw error;
    }
  });

  const shareCollection = useMutation(async (payload: any) => {
    const token = await auth.user?.getIdToken();
    if (!token) return;
    const route = `${baseurl}/collection/${payload.collection}/shares`;
    try {
      const response = await axios.post(
        route,
        { Emails: payload.emails },
        {
          headers: {
            Authorization: token
          }
        }
      );
      if (response && response.status === 200) {
        return response.data ?? 'ok';
      }
    } catch (error: any) {
      if (error?.response?.status === 403 || error?.response?.status === 401) {
        setLocalStorage('token', null);
        setLocalStorage('userData', null);
        window.open('/', '_self');
      }
      throw error;
    }
  });

  const geItemsShared = async (collection: string) => {
    try {
      const token = await auth.user?.getIdToken();
      if (!token) return;
      const route = `${baseurl}/collection/${collection}/shares`;
      const response = await axios.get(route, {
        headers: {
          Authorization: token,
          'Cache-Control': 'no-store'
        }
      });
      if (response && response.status === 200) {
        const collection = response?.data?.result ?? [];
        return collection;
      }
    } catch (error: any) {
      if (
        error?.response?.status == 403 ||
        error?.message === 'auth.user?.getIdToken is not a function' ||
        error?.response?.status == 401
      ) {
        setLocalStorage('token', null);
        setLocalStorage('userData', null);
        window.open('/', '_self');
      }
      throw error;
    }
  };

  return {
    geAllCollections,
    geCollection,
    createCollection,
    updateCollection,
    geCollectionItems,
    createCollectionItem,
    updateCollectionItem,
    deleteCollectionItem,
    shareCollection,
    geItemsShared
  };
}
